var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hzc-two-page-header"},[_vm._v(" 当前位置："),_c('span',{staticClass:"back",on:{"click":_vm.back}},[_vm._v("焦炭")]),_vm._v(" > "+_vm._s(_vm.typeTitle)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }